import { createSlice } from '@reduxjs/toolkit';

const SaveCredentialsReducer = createSlice({
    name:'bar_controller',
    initialState:{},
    reducers:{
        saveCredentials:{
            reducer:(state, action) => (state = action.payload),
            prepare: (value) => ({ payload: value }),
        }
    }
})

export const {saveCredentials} = SaveCredentialsReducer.actions;
export default SaveCredentialsReducer.reducer
